
import ReactDOM from 'react-dom';
import {AppLink as Link, AppWrapper, MasterBlocks} from "../components/helpers";
import app from "../components/app";
import Editor from "./editor";

import { useEffect, useState } from "react";

const openPopup = function(data, callback){
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<MasterBlocks data={data} callback={callback} />, div);
}

export default function Blocks(props) {
    const [data, setData] = useState([]);
    const [item, setItem] = useState(null);
   
    useEffect(() => {
        if(props.category) {
            app.fetchPost({
                "method":"getAllBlocks",
                //"lang":"en"
                "id":props.category
            }).then(function(response){
                let itemData = null;
                if(response.data) {
                    response.data.forEach(function(v){ 
                        if(v.id === props.category) {
                            itemData = JSON.parse(JSON.stringify(v))
                        }
                    });
                    if(itemData) {
                        itemData["data"] = JSON.parse(itemData["data"]);
                        itemData["dynamicAIData"] = [itemData["data"]];
                        setItem(itemData);
                    }
                }
            })
        }
        else {
            app.fetchPost({
                "method":"getAllBlocks",
                "lang":"en"
            }).then(function(response){
                if(response.data) { 
                    // let nit = response.data
                    // nit = nit.map(function(v){  
                    //         return JSON.parse(v.data) 
                    // });
                    // console.log("nit", nit)
                    setData(response.data);
                }
            })
        }
       
    }, [props.category]);

    const updateItem = function(key, value) {
        let itemData = JSON.parse(JSON.stringify(item));
        itemData[key] = value;
        setItem(itemData);
    }

    const saveItem = function(item, mode) {
        app.fetchPost({
            "method":"saveBlocks",
            "id":item.id,
            "title":item.title,
            "page":item.page,
            "master":item.master,
            "type":item.type,
            "status":true,
            "data":JSON.stringify(item.data)
        }, mode).then(function(response){
            if(!item.id) {
                if(response.data._id) {
                    window.pushState("blocks", response.data._id);
                }
            }
        //    console.log("response", item.data);
        })
    }

    const deleteItem = function(index) {
        if(window.confirm("do you really want to delete this block")) {
            app.fetchPost({
                "method":"deleteBlocks",
                "id":data[index].id
            }).then(function(){
                setData(data.filter(function(v, i){
                    if(i === index) {
                        return false;
                    }
                    return true;
                }))
            })
        }
    }

    let html = "";
    const button =   <div className="w-100 pt-3">
    <button  className="btn btn-lg btn-outline-success" onClick={() => openPopup(null, saveItem)}>Add Block</button>
    </div>
    // console.log("item", item.dynamicAIData)
    if(props.category) {

        if(item) {
            
            return <Editor type="block-edit" data={item} callback={function(value, mode){
                let itemData = JSON.parse(JSON.stringify(item));
                itemData["data"] = value.dynamicAIData[0];
                saveItem(itemData, mode);
            }} />
        }
        html = <div className="w-100 p-2">Loading</div>
    }
    else {
        if(data.length) {
            html = <div className="container blocks-container p-2">
                <div className="row">
                {
                    data.map(function(v, i){
                        let preData = ""
                        try {
                            if (v.data) {
                              // Attempt to parse JSON
                               preData = JSON.parse(v.data); 
                            } else {
                              console.log("No data to parse");
                            }
                          } catch (err) { 
                            console.error("Error parsing JSON:", err); 
                        }
                        return  <div className="col-3 mb-4" key={`block-${i}`} widget-Type={preData.widgetType}>
                            <div className="card w-100">
                            <img alt={preData.widgetType} src={`${window.aiHost}/images/image-2x1.png`} className="card-img-top" style={{backgroundImage:`url(https://media.mediadirhub.com/layouts/${(app.getDevice() === "mobile"?'mobile':'website')}/blocks/${app.appLang()}/${v.id}.png?version=${window.aiVersion})`}} />
                            <div className="card-body">
                                <h5 className="card-title"> <span>{v.title}</span></h5>
                            </div>
                            <div className="card-footer">
                                <a href={`/blocks/${v.id}`} className="btn btn-sm btn-secondary">Edit</a>
                                <button type="button" className="btn btn-sm btn-danger ms-2 d-none" onClick={() => deleteItem(i)}>Delete</button>
                                <a href={`/blocks/${v.id}/lang`} className="btn btn-sm btn-secondary ms-2">Convert</a>
                            </div>
                            </div>
                        </div>
                    })
                }
            </div>
           
            <div className="container blocks-container p-2">
                {button}
            </div>
            </div>
        }
        else {
            html = <div className="container blocks-container p-2">
            {button}
            </div>
        }
    }
   
    return <AppWrapper>
     {html}
    </AppWrapper>
}